// extracted by mini-css-extract-plugin
module.exports = {"singlePackage__title":"FinAid_singlePackage__title__3osNj","singlePackage":"FinAid_singlePackage__242vB","main":"FinAid_main__3XLRQ","college_id":"FinAid_college_id__3wrKf"};